import React, { useEffect, useState } from 'react'
import Icon from "react-icons-kit";
import { androidArrowBack } from "react-icons-kit/ionicons/androidArrowBack";
import styles from "../ExternalDash/Verifier/RequestVerifications/RequestDetails.module.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import API from '../../../ApiConfig'
import cogoToast from "cogo-toast-react-17-fix";
import SlideUpWrapper from '../../../components/Transitions/SlideUpWrapper';
import useRefreshToken from '../../../Hooks/usegenerateToken';
import Loader from '../../../components/Loader';
import { _ToNormal, Delay, setDate } from '../../../Utils/helper';
import { BASE_URL, GET_DOCUMENT_FORM_FIELDS, INSERT_ISSUER_DOCUMENT, PUBLISH_DOCUMENT_BY_UUID, USER_TOKEN } from '../../../Utils/constant';
import { useSelector } from 'react-redux';
import AnimatedLoader from '../../../components/AnimationLoader';
import Dropdown from '../../../components/Inputs/Dropdown';

// The employment field is identified by its normalized label. Options come from
// the field metadata when supplied, otherwise fall back to this list.
const EMPLOYMENT_FIELD_LABEL = "Employment Type";
const EMPLOYMENT_OPTIONS = ["Intern", "Full-time", "Trainee"];

const isEmploymentField = (field) =>
  typeof field?.label === "string" && field.label.trim() === EMPLOYMENT_FIELD_LABEL;

const IssueDocumentRequest = () => {
    useRefreshToken(BASE_URL + USER_TOKEN);
    const [loading, setLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
  
    const navigate = useNavigate();
    const holder_data=JSON.parse(localStorage.getItem("holder_data"))
    const location = useLocation();
    
    const documentId = holder_data?.document_id;

    const verificationReqId=holder_data?.verifier_request_id
  
    const [fieldsData, setFieldsData] = useState([]);
    const user_data=useSelector(state=>state.User)
  
    useEffect(() => {
      getFields();
    }, []);
    const getFields = () => {
      setLoading(true);
      API.get(GET_DOCUMENT_FORM_FIELDS +documentId + `?verifier_request_id=${verificationReqId}`)
        .then((res) => {
          if (res.data.status == 200) {
            setLoading(false);
            let ListData=res.data?.data
            ListData.map((item,index)=>{
                item.id=index+1
                item.label=_ToNormal(item.field_name)
                item.isRequired = item.is_required || false
                item.fieldType = 1
                item.originalInputValue= item.value || ""
                item.value = item.value? item.value:""
                item.checked=item.value?true:false
                item.error=""
                if (item.field_name === "Employee Id") {
                    item.disabled = true
                    item.checkboxDisabled = true
                }
                if (isEmploymentField(item)) {
                    item.fieldType = 2
                    item.options = item.options ?? EMPLOYMENT_OPTIONS
                }
            })
            const hideFields=["Document State", "Reason For Hold"]
            const filteredList=  ListData.filter((field=>!hideFields.includes(field.field_name)))
              setFieldsData(filteredList);
            }
        })
        .catch((err) => {
            setLoading(false)
          cogoToast.error(err.response.data.message);
        });
    };
    const handleChange = (id, newValue) => {
        setFieldsData((prev) =>
          prev.map((field) => {
            if (field.id === id) {
              let error = "";
      
              // Required validation
              if (field.isRequired && newValue.trim() === "") {
                error = "*Required!";
                field.checked=false
              }
              if(field.originalInputValue===newValue){
                field.checked=true
              }
              else if(field.originalInputValue!==newValue){
                field.checked=false
              }
      
              // Regex validation
              else if (
                field.regex &&
                field.regex[0] &&
                newValue.trim() !== ""
              ) {
                const pattern = new RegExp(field.regex[0]);
      
                if (!pattern.test(newValue)) {
                  error = `Invalid ${field.label}`;
                }
              }
      
              return {
                ...field,
                value: newValue,
                error,
              };
            }
      
            return field;
          })
        );
      };
    const handleCheckBox = (id, checked) => {
      setFieldsData((prev) =>
        prev.map((fields, i) =>{
            return(
          fields.id === id ? { ...fields, checked, value: checked ? fields.originalInputValue: "", error:"" } : fields
            )
        }
        )
      );
    };



    const validateData = () => {
        let isValid = true;
      
        const temp = fieldsData.map((item) => {
          let error = "";
      
          // Required validation
          if (item.isRequired && item.value?.toString().trim() === "" && item.is_required) {
            error = "*Required!";
            isValid = false;
          }
      
          // Regex validation
          else if (
            item.regex &&
            item.regex[0] &&
            item.value?.toString().trim() !== ""
          ) {
            const pattern = new RegExp(item.regex[0]);
      
            if (!pattern.test(item.value)) {
              error = `Invalid ${item.label}`;
              isValid = false;
            }
          }
      
          return {
            ...item,
            error,
          };
        });
        const Field=[
          ...temp,
          {
            field_name: "Document State",
            is_required: true,
            placeholder: "DRAFT or PUBLISHED",
            type: "string",
            value: "PUBLISHED",
            id: 5,
            label: "Document State",
            isRequired: true,
            fieldType: 1,
            originalInputValue: "PUBLISHED",
            checked: true,
            error: ""
        }
        ]
        
        if (!isValid) {
          setFieldsData(temp);
          cogoToast.error("Please Enter valid inputs!");
          return false;
        }

        handleSubmit(Field);
        return true;
      };
      const publishDocument=async(docId)=>{
        setSubmitLoading(true)
        await Delay()
    let single_publish_url=PUBLISH_DOCUMENT_BY_UUID
    const payload = [docId.toString()]
    API.post(single_publish_url,payload)
      .then(res => {
        setSubmitLoading(false)
        localStorage.removeItem("holder_data")
        let navigateto="/dashboard/verification_requests"
        if (res.data.status === 200) {
          cogoToast.success(res.data.message)
          setTimeout(() => navigate(navigateto), 2000)
        }
      })
      .catch(err => {
        setSubmitLoading(false)
        cogoToast.error(err.response?.data?.message)
        
      })
    }
      async function handleSubmit(data) {
        let params = {}
        let URL = INSERT_ISSUER_DOCUMENT
        params.doc_data = {}
        data.forEach(item => {
            params.doc_data[item.field_name] = item.value
            params.issuer_id = user_data.id
            params.document_id = documentId
            params.verification_request_id = verificationReqId
        })

        setSubmitLoading(true)
        await Delay()
        API.post(URL, { ...params })
            .then(res => {
                setSubmitLoading(false)
                publishDocument(res.data?.data?.issued_document_id)

            })
            .catch(err => {
                setSubmitLoading(false)
                    cogoToast.error(err.response.data.detail[0].error)

            })
    }
  return (
        <>
          <div style={{ width: "100%" }}>
            <Loader isOpen={loading} />
            <AnimatedLoader isOpen={submitLoading} loadingText={"Please Wait..."}/>
            <SlideUpWrapper direction="slide-left">
              <div>
                <h2 className={styles.header}>
                  <Icon
                    icon={androidArrowBack}
                    size={"1.2rem"}
                    onClick={() =>{
                      navigate(
                        `/dashboard/verification_requests`
                      )
                      localStorage.removeItem("holder_data")
                    }
                    }
                    style={{ cursor: "pointer" }}
                  />
                  {loading ? (
                    <div className="shimmer" style={{ width: "10rem" }} />
                  ) : (
                    "Issue Document"
                  )}
                </h2>
                <div className={styles.section}>
                  <div className={styles.mainContainer}>
                      <div>
                        <table style={{ width: "100%", textAlign: "left", border:"1px solid lightgray", borderRadius:"10px" }}>
                        <tr
                                  className="credentials-header1"
                                  style={{ alignItems: "center" }}
                                >

                                  <td
                                    className="credentials-header1"
                                    style={{ alignItems: "center" }}
                                  >
                                    <td
                                      className="credentials-td"
                                      style={{
                                        justifyContent: "flex-start",
                                        width: "15rem",
                                        fontWeight:"700",
                                        fontSize:"18px"
                                      }}
                                    >
                                        Fields Name
                                        </td>
                                    </td>
                                    <td
                                    className="credentials-header1"
                                    style={{ alignItems: "center" }}
                                  >
                                    <td
                                      className="credentials-td"
                                      style={{
                                        justifyContent: "flex-start",
                                        width: "15rem",
                                        fontWeight:"700",
                                        fontSize:"18px"
                                      }}
                                    >
                                        Verifier Value
                                        </td>
                                    </td>
                                    <td
                                    className="credentials-header1"
                                    style={{ alignItems: "center" }}
                                  >
                                    <td
                                      className="credentials-td"
                                      style={{
                                        justifyContent: "flex-start",
                                        width: "15rem",
                                        fontWeight:"700",
                                        fontSize:"18px"
                                      }}
                                    >
                                        Action
                                        </td>
                                    </td>
                                    <td
                                    className="credentials-header1"
                                    style={{ alignItems: "center" }}
                                  >
                                    <td
                                      className="credentials-td"
                                      style={{
                                        justifyContent: "flex-start",
                                        width: "15rem",
                                        fontWeight:"700",
                                        fontSize:"18px"
                                      }}
                                    >
                                        Issued Value
                                        </td>
                                    </td>
                                    </tr>
                          <tbody>
                            {fieldsData &&
                              fieldsData.map((item, index) => (
                                <tr
                                  key={index}
                                  className="credentials-header1"
                                  style={{ alignItems: "center" }}
                                >
                                  <td
                                    key={index}
                                    className="credentials-header1"
                                    style={{ alignItems: "center" }}
                                  >
                                    <td
                                      className="credentials-td"
                                      style={{
                                        justifyContent: "flex-start",
                                        width: "15rem",
                                      }}
                                    >
                                      {_ToNormal(item.field_name)} {item.isRequired&& <span style={{color:"red"}}>*</span>}
                                    </td>
                                  </td>
                                  <td
                                    key={index}
                                    className="credentials-header1"
                                    style={{ alignItems: "center" }}
                                  >
                                    <td
                                      className="credentials-td"
                                      style={{
                                        justifyContent: "flex-start",
                                        width: "15rem",
                                      }}
                                    >
                                      {item.originalInputValue}
                                    </td>
                                  </td>
                                  <td
                                    key={index}
                                    className="credentials-header1"
                                    style={{ alignItems: "center" }}
                                  >
                                    <td
                                      className="credentials-td"
                                      style={{
                                        justifyContent: "flex-start",
                                        width: "15rem",
                                      }}
                                    >
                                      {/* <input type="checkbox" className={styles.input} checked={item.checked} onChange={(e)=>handleCheckBox(item.id,e.target.checked)}/>  */}
                                      <div className="checkbox-wrapper-22">
                                        <label
                                          className="switch"
                                          htmlFor={`checkbox ${item.id}`}
                                        >
                                          <input
                                            type="checkbox"
                                            id={`checkbox ${item.id}`}
                                            checked={item.checked}
                                            onChange={(e) =>
                                              handleCheckBox(
                                                item.id,
                                                e.target.checked
                                              )
                                            }
                                            disabled={item.disabled}
                                          />
                                          <div className="slider round"></div>
                                        </label>
                                      </div>
                                    </td>
                                  </td>
                                  <td
                                    key={index}
                                    className="credentials-header1"
                                    style={{ alignItems: "center" }}
                                  >
                                    <td
                                      className="credentials-td"
                                      style={{
                                        justifyContent: "flex-start",
                                        width: "15rem",
                                      }}
                                    >
                                      {" "}
                                      {item.fieldType === 2 ? (
                                        <Dropdown
                                          options={item.options}
                                          value={item.value}
                                          placeholder={item.placeholder || "Select..."}
                                          disabled={item.checkboxDisabled}
                                          onChange={(val) =>
                                            handleChange(item.id, val)
                                          }
                                        />
                                      ) : (
                                        <input
                                          type="text"
                                          className={styles.input}
                                          value={item.value}
                                          onChange={(e) =>
                                            handleChange(item.id, e.target.value)
                                          }
                                          disabled={item.checkboxDisabled}
                                        />
                                      )}
                                      {item.error && (
                                        <p
                                            style={{
                                            color: "red",
                                            fontSize: "12px",
                                            marginTop: "4px",
                                            }}
                                        >
                                            {item.error}
                                        </p>
                                        )}
                                    </td>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
    
                          <div
                            style={{
                              display: "flex",
                              alignItem: "center",
                              justifyContent: "center",
                              marginTop: "10px",
                            }}
                          >
                            <button
                              type="submit"
                              className="btn btn-primary"
                              onClick={(e) => validateData()}
                            >
                              {submitLoading ? "Submitting..." : "Submit"}
                            </button>
                          </div>
                      </div>
                    {loading && (
                      <div className="shimmer" style={{ width: "10rem" }}></div>
                    )}
                  </div>
                </div>
              </div>
            </SlideUpWrapper>
          </div>
        </>
    
  )
}

export default IssueDocumentRequest